import { render } from "./forget.vue?vue&type=template&id=28a1fb8e&scoped=true"
import script from "./forget.vue?vue&type=script&lang=js"
export * from "./forget.vue?vue&type=script&lang=js"

import "./forget.vue?vue&type=style&index=0&id=28a1fb8e&scoped=true&lang=css"

import exportComponent from "E:\\ddemo\\zhongxiaoqi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a1fb8e"]])

export default __exports__